// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Identidade visual DFP Agro Operational — AgriTech Premium.
   Tokens compartilhados por toda a interface. As variáveis são preservadas
   em nome (remapeadas em valor) para que o restante do CSS continue válido. */

:root {
  /* Identidade institucional */
  --verde-institucional: #123f2b;
  --verde-primario: #1f6846;
  --verde-primario-hover: #1a573a;
  --verde-suave: #e9f0e8;
  --fundo-principal: #f6f7f2;
  --superficie: #ffffff;
  --superficie-2: #f9faf6;
  --superficie-3: #f1f3ec;

  /* Compatibilidade com o vocabulário anterior do Viewer */
  --papel: var(--superficie);
  --papel-2: var(--superficie-2);
  --papel-3: var(--superficie-3);
  --fundo-mapa: var(--fundo-principal);

  /* Tipografia e cor de texto */
  --tinta: #17251f;
  --tinta-media: #4a5b54;
  --tinta-suave: #6b7a72;
  --tinta-invertida: #ffffff;

  /* Traços e divisores */
  --linha: #e2e6dd;
  --linha-forte: #c8d0c3;

  /* Ação e foco */
  --realce: var(--verde-primario);
  --realce-fraco: var(--verde-suave);
  --foco: #2a8a5f;

  /* Penas das camadas (inalteradas para não afetar o MapLibre) */
  --pena-unidade: #2b6ea8;
  --pena-sobreposicao: #9c3f6a;
  --pena-buffer: #a9741f;
  --pena-selecao: #0d3f66;
  --pena-pais: #a4adb6;
  --pena-recorte: #6b8a6f;

  /* Estados */
  --ok: #2e7d5b;
  --alerta: #b26a00;
  --erro: #b3261e;

  /* Tipografia — Inter com fallback sans-serif */
  --fonte-ui:
    'Inter', system-ui, -apple-system, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
  --fonte-dados:
    'JetBrains Mono', ui-monospace, 'SFMono-Regular', Consolas, 'Liberation Mono', monospace;

  --texto-xs: 0.75rem;
  --texto-sm: 0.8125rem;
  --texto-md: 0.875rem;
  --texto-lg: 1rem;
  --texto-xl: 1.125rem;
  --texto-2xl: 1.5rem;

  /* Espaçamento em múltiplos de 4px */
  --espaco-1: 4px;
  --espaco-2: 8px;
  --espaco-3: 12px;
  --espaco-4: 16px;
  --espaco-5: 24px;
  --espaco-6: 32px;
  --espaco-7: 48px;

  /* Raios */
  --raio: 8px;
  --raio-pequeno: 6px;
  --raio-grande: 12px;

  --sombra-flutuante: 0 1px 2px rgba(18, 63, 43, 0.06), 0 6px 16px rgba(18, 63, 43, 0.08);
  --sombra-card: 0 1px 2px rgba(18, 63, 43, 0.04), 0 2px 8px rgba(18, 63, 43, 0.05);
  --sombra-sidebar: 1px 0 0 var(--linha);

  /* Dimensões do layout global */
  --altura-topo: 64px;
  --largura-sidebar: 248px;
  --largura-sidebar-recolhida: 64px;
  --largura-exploracao: 420px;
  --largura-inspetor: 320px;

  /* Identidade visual do painel direito de exploração (verde institucional profundo) */
  --painel-exploracao-fundo: #0d3022;
  --painel-exploracao-fundo-2: #0a2419;
  --painel-exploracao-linha: rgba(255, 255, 255, 0.16);

  --transicao: 160ms ease-out;
}
`, "",{"version":3,"sources":["webpack://./src/styles/tokens.css"],"names":[],"mappings":"AAAA;;8EAE8E;;AAE9E;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;EAC/B,sBAAsB;EACtB,0BAA0B;EAC1B,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;;EAEvB,yDAAyD;EACzD,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,oCAAoC;;EAEpC,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;;EAE1B,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;;EAEtB,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;EAClC,eAAe;;EAEf,+DAA+D;EAC/D,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;;EAEvB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,eAAe;;EAEf,+CAA+C;EAC/C;sFACoF;EACpF;4FAC0F;;EAE1F,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;;EAEnB,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;;EAEnB,uFAAuF;EACvF,iFAAiF;EACjF,sCAAsC;;EAEtC,+BAA+B;EAC/B,mBAAmB;EACnB,wBAAwB;EACxB,iCAAiC;EACjC,2BAA2B;EAC3B,yBAAyB;;EAEzB,qFAAqF;EACrF,kCAAkC;EAClC,oCAAoC;EACpC,oDAAoD;;EAEpD,2BAA2B;AAC7B","sourcesContent":["/* Identidade visual DFP Agro Operational — AgriTech Premium.\r\n   Tokens compartilhados por toda a interface. As variáveis são preservadas\r\n   em nome (remapeadas em valor) para que o restante do CSS continue válido. */\r\n\r\n:root {\r\n  /* Identidade institucional */\r\n  --verde-institucional: #123f2b;\r\n  --verde-primario: #1f6846;\r\n  --verde-primario-hover: #1a573a;\r\n  --verde-suave: #e9f0e8;\r\n  --fundo-principal: #f6f7f2;\r\n  --superficie: #ffffff;\r\n  --superficie-2: #f9faf6;\r\n  --superficie-3: #f1f3ec;\r\n\r\n  /* Compatibilidade com o vocabulário anterior do Viewer */\r\n  --papel: var(--superficie);\r\n  --papel-2: var(--superficie-2);\r\n  --papel-3: var(--superficie-3);\r\n  --fundo-mapa: var(--fundo-principal);\r\n\r\n  /* Tipografia e cor de texto */\r\n  --tinta: #17251f;\r\n  --tinta-media: #4a5b54;\r\n  --tinta-suave: #6b7a72;\r\n  --tinta-invertida: #ffffff;\r\n\r\n  /* Traços e divisores */\r\n  --linha: #e2e6dd;\r\n  --linha-forte: #c8d0c3;\r\n\r\n  /* Ação e foco */\r\n  --realce: var(--verde-primario);\r\n  --realce-fraco: var(--verde-suave);\r\n  --foco: #2a8a5f;\r\n\r\n  /* Penas das camadas (inalteradas para não afetar o MapLibre) */\r\n  --pena-unidade: #2b6ea8;\r\n  --pena-sobreposicao: #9c3f6a;\r\n  --pena-buffer: #a9741f;\r\n  --pena-selecao: #0d3f66;\r\n  --pena-pais: #a4adb6;\r\n  --pena-recorte: #6b8a6f;\r\n\r\n  /* Estados */\r\n  --ok: #2e7d5b;\r\n  --alerta: #b26a00;\r\n  --erro: #b3261e;\r\n\r\n  /* Tipografia — Inter com fallback sans-serif */\r\n  --fonte-ui:\r\n    'Inter', system-ui, -apple-system, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;\r\n  --fonte-dados:\r\n    'JetBrains Mono', ui-monospace, 'SFMono-Regular', Consolas, 'Liberation Mono', monospace;\r\n\r\n  --texto-xs: 0.75rem;\r\n  --texto-sm: 0.8125rem;\r\n  --texto-md: 0.875rem;\r\n  --texto-lg: 1rem;\r\n  --texto-xl: 1.125rem;\r\n  --texto-2xl: 1.5rem;\r\n\r\n  /* Espaçamento em múltiplos de 4px */\r\n  --espaco-1: 4px;\r\n  --espaco-2: 8px;\r\n  --espaco-3: 12px;\r\n  --espaco-4: 16px;\r\n  --espaco-5: 24px;\r\n  --espaco-6: 32px;\r\n  --espaco-7: 48px;\r\n\r\n  /* Raios */\r\n  --raio: 8px;\r\n  --raio-pequeno: 6px;\r\n  --raio-grande: 12px;\r\n\r\n  --sombra-flutuante: 0 1px 2px rgba(18, 63, 43, 0.06), 0 6px 16px rgba(18, 63, 43, 0.08);\r\n  --sombra-card: 0 1px 2px rgba(18, 63, 43, 0.04), 0 2px 8px rgba(18, 63, 43, 0.05);\r\n  --sombra-sidebar: 1px 0 0 var(--linha);\r\n\r\n  /* Dimensões do layout global */\r\n  --altura-topo: 64px;\r\n  --largura-sidebar: 248px;\r\n  --largura-sidebar-recolhida: 64px;\r\n  --largura-exploracao: 420px;\r\n  --largura-inspetor: 320px;\r\n\r\n  /* Identidade visual do painel direito de exploração (verde institucional profundo) */\r\n  --painel-exploracao-fundo: #0d3022;\r\n  --painel-exploracao-fundo-2: #0a2419;\r\n  --painel-exploracao-linha: rgba(255, 255, 255, 0.16);\r\n\r\n  --transicao: 160ms ease-out;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
